/**
 * SOLID Review
 * S — Strong. One use case: the gate's Accept — one consent per reviewed document, recorded in order.
 * O — Strong. Which consents are recorded is the Domain's plan.
 * L — Strong. Implements its use-case role exactly.
 * I — Strong. `execute`.
 * D — Strong. The decisions and legal-server ports and the session's step, injected.
 */
import type { IContextRequest } from '../ports/IContextRequest';
import type { ICommandLegalAcceptance } from '../../domain/ports/schemas/LegalMoves';
import type { TPortOutcome } from '../ports/PortResult';
import type { IUseCase } from '../uml-components/IUseCase';
import { DONE } from '../shared/ClientSteps';
import type { IConfigDepLegal } from './IConfigDepLegal';

/** The gate's Accept (FE4a): Terms, then Privacy; the first that fails stops the rest, and says why. */
export class AcceptLegalTermsUseCase implements IUseCase<ICommandLegalAcceptance, TPortOutcome> {
  constructor(private readonly deps: IConfigDepLegal) {}

  async execute(ctx: IContextRequest, command: ICommandLegalAcceptance): Promise<TPortOutcome> {
    const { decisions, step, legal } = this.deps;
    const plan = await step.run(ctx, (input) => decisions.planLegalAcceptance(ctx, input, command));
    if (!plan.success) return plan;
    for (const consent of plan.value.consents) {
      const recorded = await legal.recordConsent(ctx, consent);
      if (!recorded.success) return recorded;
    }
    return DONE;
  }
}
